import { render, staticRenderFns } from "./group-relationship-batch-application.vue?vue&type=template&id=ad076574&scoped=true"
import script from "./group-relationship-batch-application.vue?vue&type=script&lang=js"
export * from "./group-relationship-batch-application.vue?vue&type=script&lang=js"
import style0 from "./group-relationship-batch-application.vue?vue&type=style&index=0&id=ad076574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad076574",
  null
  
)

export default component.exports